import React, { useLayoutEffect } from 'react'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles({ name: 'GettingStartedStep' })(() => ({
  root: {
    width: '100%',
    display: 'grid',
    minHeight: '100%',
  },
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%',
  },
}))

export const GettingStartedStep = (props: React.PropsWithChildren) => {
  const { classes } = useStyles()

  useLayoutEffect(() => {
    document.getElementById('getting-started-content')?.scrollTo(0, 0)
  }, [])
  return (
    <div className={classes.root}>
      <div className={classes.container}>{props.children}</div>
    </div>
  )
}
